import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { DepartmentAdminDto } from '../../dtos/department-admin.dto';
import { DepartmentProfileDto, UpdateDepartmentProfilePayload } from '../../dtos/department-profile.dto';

// Per ProVet's OpenAPI spec, `Email` is the only Department field with a writable counterpart on
// this PUT. Website/LogoUrl/AddressInfo/SocialLinks have no writable ProVet endpoint and are
// intentionally absent here -- see `UpdateDepartmentInput`'s doc comment.
export interface UpdateDepartmentPayload {
  readonly Name: string;
  readonly ResponsibleEmail: string | null;
  readonly TimeZone: string | null;
  readonly IsActive: boolean;
  readonly Email: string | null;
}

@Injectable()
export class DepartmentsAdminRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public list(organizationId: number): Observable<DepartmentAdminDto[]> {
    return this.http.get<DepartmentAdminDto[]>(
      `${this.apiUrl}${API_ENDPOINTS.departments.list(organizationId)}`,
    );
  }

  public getById(organizationId: number, departmentId: number): Observable<DepartmentAdminDto> {
    return this.http.get<DepartmentAdminDto>(
      `${this.apiUrl}${API_ENDPOINTS.departments.byId(organizationId, departmentId)}`,
    );
  }

  public update(
    organizationId: number,
    departmentId: number,
    payload: UpdateDepartmentPayload,
  ): Observable<DepartmentAdminDto> {
    return this.http.put<DepartmentAdminDto>(
      `${this.apiUrl}${API_ENDPOINTS.departments.byId(organizationId, departmentId)}`,
      payload,
    );
  }

  public getProfile(organizationId: number, departmentId: number): Observable<DepartmentProfileDto> {
    return this.http.get<DepartmentProfileDto>(
      `${this.apiUrl}${API_ENDPOINTS.departments.profile(organizationId, departmentId)}`,
    );
  }

  public updateProfile(
    organizationId: number,
    departmentId: number,
    payload: UpdateDepartmentProfilePayload,
  ): Observable<DepartmentProfileDto> {
    return this.http.put<DepartmentProfileDto>(
      `${this.apiUrl}${API_ENDPOINTS.departments.profile(organizationId, departmentId)}`,
      payload,
    );
  }
}
